import React from "react";
import { Button, Row, Col, Typography } from "antd";
import { DownloadOutlined, PhoneOutlined } from "@ant-design/icons";
import Back from "../assets/Ellipse/e10.svg"; // Make sure this path is correct
import F1 from "../assets/icons/f1.svg"; // Make sure this path is correct
import F2 from "../assets/icons/f2.png"; // Make sure this path is correct
import F3 from "../assets/icons/f3.png"; // Make sure this path is correct
import F4 from "../assets/icons/f4.png"; // Make sure this path is correct
import F5 from "../assets/icons/f5.svg"; // Make sure this path is correct
import F6 from "../assets/icons/f6.png"; // Make sure this path is correct
import KiddtopiaBrochure from '../assets/Kiddtopia_Brochure.pdf';

const { Title } = Typography;

const features = [
  { title: "Safe Investment", icon: F1 },
  { title: "Full Interior Setup", icon: F2 },
  { title: "Marketing Support", icon: F3 },
  { title: "Staff Training + Operational Manuals", icon: F4 },
  { title: "Monthly ROI Projection", icon: F5 },
  { title: "Full Support", icon: F6 },
];

const FranchiseOpportunity = () => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "60px 20px",
      }}
    >
      {/* Inner container to constrain content width on large screens */}
      <div
        style={{ maxWidth: "1400px", width: "100%", margin: "0 auto", textAlign: "center" }}
      >
        <Title
          level={3}
          style={{
            color: "#1B71C4",
            fontWeight: "bold",
            fontFamily: "Rowdies",
            fontSize: "clamp(28px, 4vw, 48px)", // Responsive font size
            marginBottom: "40px", // Added more space below heading
          }}
        >
          Franchise Opportunity
        </Title>

        {/* Adjusted gutter for both horizontal and vertical spacing */}
        <Row gutter={[24, 48]} justify="center" align="middle">
          {features.map((feature, index) => (
            <Col
              key={index}
              xs={12} // 2 columns on extra small screens
              sm={12} // 2 columns on small screens
              md={8} // 3 columns on medium screens
              lg={6} // 4 columns on large screens
              xl={4} // Even more columns on extra large screens if desired (adjust based on design)
              style={{ position: "relative", display: "flex", justifyContent: "center" }} // Center item within its column
            >
              <div style={{ width: "100%" }}>
                <div style={{ padding: 10 }}>
                  {" "}
                  {/* Reduced padding for smaller items */}
                  <div
                    style={{
                      width: 150, // Smaller circle
                      height: 150, // Smaller circle
                      borderRadius: "50%",
                      backgroundImage: `url(${Back})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      margin: "0 auto 10px", // Reduced margin
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="circle-container"
                  >
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      style={{ height: 100, objectFit: "contain" }} // Smaller icon
                    />
                  </div>
                  <p
                    style={{
                      display: "block",
                      fontFamily: "Outfit",
                      fontSize: "16px", // Smaller font size
                      fontWeight: 500,
                    }}
                  >
                    {feature.title}
                  </p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <div>
          <div style={{ marginTop: 60 }}>
            {" "}
            {/* More space above buttons */}
            <p
              style={{
                display: "block",
                marginBottom: 24,
                fontFamily: "Outfit",
                fontSize: "22px",
                fontWeight: 500,
              }}
            >
              Want to Get More Information?
            </p>
            <div
              style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "16px" }}
            >
              {" "}
              {/* Added gap for responsiveness */}
              <a href={KiddtopiaBrochure} download="Kiddtopia_Brochure.pdf">

              <button
                type="primary"
                className="btn"
                size="large" // Made buttons larger
                style={{ minWidth: 220 }} // Adjusted button size
              >
                <DownloadOutlined /> Download Brochure
              </button>
              </a>

              <a href="tel:+918860229232">

                <button
                className="btn"
                style={{ minWidth: 220 }} // Adjusted button size
                >
                <PhoneOutlined style={{ transform: "scale(-1)" }} /> Call Now
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default FranchiseOpportunity;